<template>
  <el-main style="margin-top: -20px; margin-left: -30px; margin-right: -15px">
    <div class="mainbody">
      <div class="tableInfo">
        <el-form
          :model="info"
          :rules="rules"
          ref="ruleForm"
          class="demo-ruleForm"
          :label-position="labelPosition"
          :inline="true"
        >
          <el-row>
            <el-col :span="6">
              <el-form-item label="企业名称" prop="title">
                <el-input
                  class="input"
                  v-model="info.title"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="地址" prop="location">
                <el-input
                  class="input"
                  v-model="info.location"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="所在地" prop="provinces">
                <el-cascader
                  class="input"
                  v-model="info.provinces"
                  :options="provinces"
                  :props="{ expandTrigger: 'hover'}"
                  @change="changeProvince"
                  clearable
                ></el-cascader>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="营业时间" prop="open_hours">
                <el-time-picker
                  is-range
                  v-model="openHours"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  placeholder="选择时间范围"
                  format="HH:mm"
                  value-format="HH:mm"
                  @change="changeOpenHours"
                >
                </el-time-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="联系电话(多个电话请用 “,” 分割)"
                prop="mobile"
              >
                <el-input
                  class="input"
                  v-model="info.mobile"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="人均价格" prop="price">
                <el-input
                  class="input"
                  type="number"
                  @keyup.native="proving(0)"
                  v-model="info.price"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="评分" prop="score">
                <el-input
                  class="input"
                  type="number"
                  @keyup.native="proving(1)"
                  v-model="info.score"
                  placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="分类" prop="type_id">
                <el-cascader
                  v-model="info.typeOptions"
                  :options="typeOptions"
                  :props="{ expandTrigger: 'hover'}"
                  @change="typeChange"
                  clearable
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="排序" prop="order">
                <el-input
                  class="input"
                  v-model="info.order"
                  onkeyup="value = value.replace(/^(0+)|[^\d]+/g, '')"
                  placeholder="请输入正整数"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="经纬度" prop="latitudeAndLongitude">
                <span slot="label">
                  经纬度（
                  <a
                    class="info-link"
                    target="_blank"
                    href="https://lbs.qq.com/getPoint/"
                    >获取经纬度</a
                  >）
                  <!-- <el-tooltip
                      class="item"
                      effect="dark"
                      content="点击链接跳转后获取到企业坐标"
                      placement="top"
                    >
                      <i class="el-icon-question"></i>
                    </el-tooltip> -->
                </span>
                <el-input
                  class="input"
                  v-model="info.latitudeAndLongitude"
                  placeholder="示例：22.34986,113.521227"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div class="enterprise-line"></div>
        <div class="input_div left image-upload">
          <p>上传缩略图</p>
          <el-upload
            :show-file-list="false"
            class="upload-demo"
            list-type="picture-card"
            :action="action"
            :data="token"
            name="image"
            :on-success="image_add"
            :before-upload="beforeUpload"
          >
            <div v-if="thumbnail == '' || thumbnail == null">
              <i slot="default" class="el-icon-plus"></i>
            </div>
            <div v-else class="show-img">
              <img :src="thumbnail" class="avatar" />
              <div class="del-img" @click.stop="remove_img">
                <i class="el-icon-delete"></i>
              </div>
            </div>

            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
          </el-upload>
        </div>
        <div class="input_div max image-upload">
          <p>上传宣传图（最多5张）</p>
          <el-upload
            class="upload-demo"
            :action="action"
            :data="token"
            name="image"
            :on-success="image_add_list"
            :file-list="shopImage"
            list-type="picture-card"
            :limit="5"
            :before-upload="beforeUpload"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div class="img-box" slot="file" slot-scope="{ file }">
              <img
                class="el-upload-list__item-thumbnail"
                :src="file.url"
                alt=""
              />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  @click="handlePictureCardPreview(file)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span
                  v-if="!disabled"
                  class="el-upload-list__item-delete"
                  @click="handleRemove_list(file)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
            <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </div>
        <div style="clear: both"></div>
        <div class="input_div" style="width: 100%">
          <p>企业详情</p>
          <el-input
            class="enterpriseDescribe"
            type="textarea"
            :rows="12"
            maxlength="500"
            show-word-limit
            resize="none"
            placeholder="请输入"
            v-model="info.rich_text"
          ></el-input>
        </div>
      </div>
    </div>
    <FootLayout v-on:saveEdit="saveEdit"></FootLayout>
  </el-main>
</template>

<script>
import { URL_PATH } from "@/config/config";
import * as StrUtils from "@/utils/strUtils.js";
import Coordinates from "@/components/layout/Coordinates";
import FootLayout from "@/components/layout/footLayout";
import VueUeditorWrap from "vue-ueditor-wrap";
export default {
  components: {
    FootLayout,
    Coordinates,
    VueUeditorWrap,
  },
  data() {
    return {
      urlPath: URL_PATH,
      labelPosition: "top",
      updateInfos: {},
      info: {
        title: "",
        location: "",
        open_hours: "",
        latitudeAndLongitude: "",
        type_id: "",
        order: 10000,
        province: "",
        city: "",
      },
      prov: "",
      id: [],
      proVal: "",
      provinces: [],
      typeOptions: [],
      shopImage: [],
      imageUrl: "",
      openHours: "",
      coordinatesInfo: {},
      rules: {
        title: [{ required: true, message: "请输入企业名称", trigger: "blur" }],
        location: [{ required: true, message: "请输入地址", trigger: "blur" }],
        provinces: [
          { required: true, message: "请选择所在地", trigger: "change" },
        ],
        open_hours: [
          { required: true, message: "请选择营业时间", trigger: "change" },
        ],
        mobile: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
        ],
        latitudeAndLongitude: [
          { required: true, message: "请输入经纬度", trigger: "blur" },
          {
            validator: (rule, value, callback) => {
              if (
                /^-?[0-9]{0,}.?[0-9]{1,},-?[0-9]{0,}.?[0-9]{1,}$/.test(value) ==
                false
              ) {
                callback(new Error("请输入正确的经纬度"));
              } else {
                callback();
              }
            },
            trigger: "blur", // 这里还有blur触发方法； 如果设为none，那么只有this.$refs[formName]['validate']时才会验证
          },
        ],
        type_id: [{ required: true, message: "请选择分类", trigger: "change" }],
      },
      // 图片上传地址
      action: URL_PATH + "api/adminAppletsShop/uploadShopImage",
      token: { token: localStorage.getItem("token") },
      thumbnail: "",
      // 放大图片
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false,
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    // 获取详情
    getInfo() {
      var id = this.$route.query.id;
      if (id == null) {
        this.info.order = 10000;
        this.shopTypeTreeList();
        return;
      }
      this.$api
        .shopInfo({
          token: localStorage.getItem("token"),
          shop_log_id: id,
        })
        .then(({ data }) => {
          data.Data.provinces = [];
          data.Data.typeOptions = [];
          this.info = data.Data;
          console.log(this.info);
          if (data.Data.latitude && data.Data.longitude) {
            this.$set(
              this.info,
              "latitudeAndLongitude",
              data.Data.latitude + "," + data.Data.longitude
            );
          }
          this.createTime = new Date(this.info.create_time * 1000);
          if (this.info.thumb != "" || this.info.thumb != null) {
            this.thumbnail = this.info.thumb;
          }
          console.log("thumbnail", this.thumbnail);
          if (this.info.open_hours) {
            this.openHours = this.info.open_hours.split("-");
          }
          if (this.info.shop_image.length > 0) {
            this.info.shop_image.forEach((image) => {
              this.shopImage.push({ url: image.link });
            });
          }
          this.getAisInfoFieldArr();
          this.shopTypeTreeList();
        })
        .catch(({ error }) => {});
    },
    // 获取类型
    shopTypeTreeList() {
      this.$api
        .shopTypeTreeList()
        .then(({ data }) => {
          data.Data.forEach((info) => {
            if (this.info.type_id == info.id) {
              this.info.typeOptions = [info.id];
            }
            var option = { value: info.id, label: info.title };
            if (info.son) {
              option.children = [];
              info.son.forEach((son) => {
                if (this.info.type_id == son.id) {
                  this.info.typeOptions = [info.id, son.id];
                }
                option.children.push({ value: son.id, label: son.title });
              });
            }
            this.typeOptions.push(option);
          });
        })
        .catch(({ error }) => {});
    },
    // 获取省份城市
    getAisInfoFieldArr() {
      this.$api
        .getRegion({})
        .then(({ data }) => {
          let provinceOptions = data.Data;
          provinceOptions.forEach((provin) => {
            if (provin.province != "国外") {
              if (this.info.province == provin.province) {
                this.info.provinces = [provin.province];
              }
              var option = {
                value: provin.province,
                label: provin.province,
              };
              if (provin.city) {
                option.children = [];
                provin.city.forEach((son) => {
                  if (this.info.city == son.city) {
                    this.info.provinces = [provin.province, son.city];
                  }
                  option.children.push({ value: son.city, label: son.city });
                });
              }
              this.provinces.push(option);
            } else {
              if (this.info.province == provin.province) {
                this.info.provinces = [provin.province];
              }
              var option = {
                value: provin.province,
                label: provin.province,
              };
              this.provinces.push(option);
            }
          });
          console.log("所在地", this.info.provinces);
        })
        .catch(({ error }) => {});
    },
    changeProvince(value) {
      if (value) {
        this.info.provinces = value;
      } else {
        this.info.provinces = [];
      }
    },
    // 编辑
    updateInfo: function (form) {
      this.$api
        .updateShop(form)
        .then(({ data }) => {
          // debugger
          this.$message({
            message: "编辑成功",
            type: "success",
          });
          setTimeout(() => {
            this.$router.back(-1);
          }, 500);
          // this.getInfo();
        })
        .catch(({ error }) => {});
    },
    // 营业时间
    changeOpenHours(value) {
      if (value) {
        this.info.open_hours = value[0] + "-" + value[1];
      } else {
        this.info.open_hours = "";
      }
    },
    // 店铺类型
    typeChange(value) {
      if (value) {
        this.info.type_id = value[value.length - 1];
      } else {
        this.info.type_id = "";
      }
    },
    // 选择图片
    openImage(thumb) {
      this.thumb = thumb;
      document.getElementById("uploadfile").click();
    },
    openFolder(e) {
      var that = this;
      var image = e.target.files[0];
      var reader = new FileReader();
      reader.onload = function (evt) {
        if (that.thumb) {
          that.imageUrl = evt.target.result;
        }
      };
      reader.readAsDataURL(image);
      if (this.thumb) {
        this.info.thumb = image;
      } else {
        // 宣传图 去上传图片 返回图片url
        var form = new FormData();
        form.append("token", localStorage.getItem("token"));
        form.append("image", image);
        this.$api
          .uploadShopImage(form)
          .then(({ data }) => {
            console.log(data);
            if (this.shopImage[0] == "") this.shopImage = [];
            this.shopImage.push({ url: this.urlPath + data.Data.link });
          })
          .catch(({ error }) => {
            console.log(error);
          });
      }
    },
    // 删除图片
    delImage(item, index) {
      if (item == "") return;
      this.$confirm("是否删除此宣传图?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.shopImage.splice(index, 1);
          if (this.shopImage.length == 0) this.shopImage.push("");
        })
        .catch(() => {});
    },
    // 保存

    saveEdit() {
      if (this.info.score && this.info.score != "") {
        if (this.info.score > 5) {
          this.$message.error("店铺评分是5分制的，超分了，最低0到5.0");
          return;
        }
        if (this.info.score < 0) {
          this.$message.error("店铺评分是5分制的，最低0到5.0");
          return;
        }
      }
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          let shopImages = [];
          if (this.shopImage.length > 0) {
            this.shopImage.forEach((item) => {
              shopImages.push(item.url);
            });
          }

          var form = new FormData();
          form.append("token", localStorage.getItem("token"));
          form.append("title", this.isEmpty(this.info.title));
          form.append("thumb", this.isEmpty(this.thumbnail));
          form.append("location", this.isEmpty(this.info.location));
          form.append(
            "latitudeAndLongitude",
            this.isEmpty(this.info.latitudeAndLongitude)
          );
          form.append("open_hours", this.isEmpty(this.info.open_hours));
          form.append("rich_text", this.isEmpty(this.info.rich_text));
          form.append("mobile", this.isEmpty(this.info.mobile));
          form.append("price", this.isEmpty(this.info.price));
          form.append("score", this.isEmpty(this.info.score));
          form.append("order", this.isEmpty(this.info.order));
          form.append("province", this.info.provinces[0]);
          form.append("city", this.info.provinces[1]);
          form.append("district", this.isEmpty(this.info.district));
          form.append("type", this.info.type_id);
          form.append("shop_image", JSON.stringify(shopImages));
          if (this.$route.query.id) {
            form.append("shop_log_id", this.info.id);
            this.updateInfo(form);
          }
        } else {
          console.log("valid", this.info.provinces);
          this.$message.error("请先完善数据");
          return false;
        }
      });
    },

    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      switch (testmsg) {
        case "jpg":
          break;
        case "png":
          break;
        default:
          this.$message.error("上传图片只能是jpg/png格式!");
          return false;
          break;
      }
      return true;
    },
    remove_img(file, fileList) {
      this.thumbnail = "";
    },
    image_add(file) {
      console.log("图片地址", file);
      this.thumbnail = URL_PATH + file.Data.link;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove_list(file, fileList) {
      var index = this.shopImage.indexOf(file);
      if (index > -1) {
        this.shopImage.splice(index, 1);
      }
    },
    image_add_list(file) {
      this.shopImage.push({ url: URL_PATH + file.Data.link });
    },
    proving(index) {
      switch (index) {
        case 0:
          this.info.price = this.info.price.replace(/\D/g, "");
          break;
        case 1:
          this.info.score = this.info.score.replace(/[^\d\.]/g, "");
          break;
      }
    },
    isEmpty(params) {
      return StrUtils.isEmpty(params) ? "" : params;
    },
  },
};
</script>

<style>
.mainbody {
  overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-top: 24px;
}
.tableInfo .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.tableInfo .input {
  display: block;
}
.operateText {
  font-size: 14px;
}

.input_div {
  width: 290px;
  margin-right: 120px;
  margin-bottom: 32px;
  float: left;
}
.input_div .input {
  width: 100%;
}
.input_div p {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  color: #595959;
  margin-bottom: 8px;
}
.enterpriseDescribe {
  width: 97%;
}
.imageDivBox {
  float: left;
  overflow: hidden;
  width: 370px;
  height: 254px;
}
.info-link {
  color: rgb(24, 144, 255);
  text-decoration: underline;
}
.image-upload {
  width: 400px;
  float: none;
}
.image-upload.max {
  width: calc(100% - 60px);
}
.show-img {
  display: flex;
  position: relative;
}
.show-img img {
  max-width: 400px;
}
.enterprise-line {
  margin: 20px 0 20px -32px;
  width: calc(100% + 32px);
  height: 1px;
  background: #e9e9e9;
}
.show-img:hover .del-img {
  display: block;
}
.del-img {
  display: none;
  transition: 0.3s all;
  position: absolute;
  top: 50%;
  padding: 0 15px;
  right: -40px;
  z-index: 22;
  transform: translateY(-50%);
}
.del-img i {
  font-size: 18px !important;
}
</style>

<style lang="less">
.el-upload-list--picture .el-upload-list__item-thumbnail {
  object-fit: cover;
}
/* element样式重置 start */
/* 去掉input尾部上下小箭头 start */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  -moz-appearance: none !important;
  -o-appearance: none !important;
  -ms-appearance: none !important;
  appearance: none !important;
  margin: 0;
}
input[type="number"] {
  -webkit-appearance: textfield;
  -moz-appearance: textfield;
  -o-appearance: textfield;
  -ms-appearance: textfield;
  appearance: textfield;
}
/* 去掉input尾部上下小箭头 end */
// .el-date-editor--daterange.el-input,
// .el-date-editor--daterange.el-input__inner,
// .el-date-editor--timerange.el-input,
// .el-date-editor--timerange.el-input__inner {
//   width: 290px;
// }
.input {
  width: 290px;
}
.custom .el-form--inline .el-form-item {
  width: 290px;
  margin-right: 120px;
}
.custom .el-form--inline .el-form-item__label {
  display: block;
  text-align: left;
}
.custom .el-form--inline .el-cascader,
.custom .el-form--inline .el-form-item__content {
  width: 100%;
}
.image-upload.left .el-upload--picture-card {
  min-width: 148px;
  width: auto;
  height: auto;
}
.image-upload .img-box {
  width: 100%;
  height: 100%;
}
.image-upload .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  object-fit: cover;
}
.image-upload.max .el-upload-list__item {
  transition: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/enterprise/enterpriseListEdit.vue